// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import {
  createValidator,
  getBinding,
} from "#stdnum-runtime";

const ik: CountryValidator<"EE", ParsedPersonId> =
  createValidator("ee.ik", 61);

export default ik;
export const compact = ik.compact;
export const format = ik.format;
export const validate = ik.validate;
export const generate = (): string =>
  ik.generate?.() ??
  (() => {
    throw new Error(
      "Validator ee.ik cannot generate values",
    );
  })();
export const parse = ik.parse;
export const twoPassCheck = (digits: string): number =>
  getBinding().eeIkTwoPassCheck(digits);
